import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from "reactstrap";
import DeployApi from "../services/appDeployApi";
import AppBuildDetail from "./AppBuildDetail";

const Platforms = {
  iOS: "iOS",
  Android: "Android",
};

const defaultBuildInfo = {
  iosBuilds: {
    buildVersion: "",
    buildNotes: "",
    releaseVersion: "",
    releaseNotes: "",
    distributionAppId: "",
    storeId: "",
  },
  androidBuilds: {
    buildVersion: "",
    buildNotes: "",
    releaseVersion: "",
    releaseNotes: "",
    distributionAppId: "",
    storeId: "",
  },
};

function AppBuildModal({ show, toggleModal, title, subdomain }) {
  const [messages, setMessages] = useState([]);
  const [buildInfo, setBuildInfo] = useState(defaultBuildInfo);

  const notify = (message) => {
    setMessages((original) => [...original.slice(-5), message]);
  };

  const getAppInfo = async () => {
    if (!subdomain) {
      setBuildInfo(defaultBuildInfo);
      return;
    }
    try {
      const appStatus = await DeployApi.getAppStatus(subdomain);
      setBuildInfo({
        iosBuilds: {
          buildVersion:
            appStatus?.iosBuildResults?.lastBuild?.shortVersion ?? "0.0.0",
          buildNotes: appStatus?.iosBuildResults?.lastBuild?.notes ?? "",
          releaseVersion:
            appStatus?.iosBuildResults?.lastRelease?.shortVersion ?? "",
          releaseNotes: appStatus?.iosBuildResults?.lastRelease?.notes ?? "",
          distributionAppId:
            appStatus?.iosBuildResults?.distributionAppId ?? "",
          storeId: appStatus?.iosBuildResults?.storeId ?? "",
        },
        androidBuilds: {
          buildVersion:
            appStatus?.androidBuildResults?.lastBuild?.shortVersion ?? "0.0.0",
          buildNotes: appStatus?.androidBuildResults?.lastBuild?.notes ?? "",
          releaseVersion:
            appStatus?.androidBuildResults?.lastRelease?.shortVersion ?? "",
          releaseNotes:
            appStatus?.androidBuildResults?.lastRelease?.notes ?? "",
          distributionAppId:
            appStatus?.androidBuildResults?.distributionAppId ?? "",
          storeId: appStatus?.androidBuildResults?.storeId ?? "",
        },
      });
    } catch (err) {
      console.log(err);
      if (err?.response?.status === 404) {
        notify({
          color: "warning",
          text: `No build information for: ${subdomain}`,
        });
        setBuildInfo({
          iosBuilds: {
            ...defaultBuildInfo.iosBuilds,
            buildVersion: "0.0.0",
          },
          androidBuilds: {
            ...defaultBuildInfo.androidBuilds,
            buildVersion: "0.0.0",
          },
        });
        return;
      }
      notify({
        color: "danger",
        text: "Unspecified error looking up subdomain",
      });
      setBuildInfo(defaultBuildInfo);
    }
  };

  useEffect(() => {
    console.log({ subdomain });
    setMessages([]);
    getAppInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subdomain]);

  return (
    <div>
      <Modal isOpen={show} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>{title}</ModalHeader>
        <ModalBody>
          {messages.map((message) => (
            <Alert color={message.color ?? "info"}>{message.text}</Alert>
          ))}
          <AppBuildDetail
            subdomain={subdomain}
            buildVersion={buildInfo?.iosBuilds?.buildVersion}
            buildNotes={buildInfo?.iosBuilds?.buildNotes}
            releaseVersion={buildInfo?.iosBuilds?.releaseVersion}
            releaseNotes={buildInfo?.iosBuilds?.releaseNotes}
            platform={Platforms.iOS}
            storeId={buildInfo?.iosBuilds?.storeId}
            distributionAppId={buildInfo?.iosBuilds?.distributionAppId}
            messages={messages}
            notify={notify}
          />
          <AppBuildDetail
            subdomain={subdomain}
            buildVersion={buildInfo?.androidBuilds?.buildVersion}
            buildNotes={buildInfo?.androidBuilds?.buildNotes}
            releaseVersion={buildInfo?.androidBuilds?.releaseVersion}
            releaseNotes={buildInfo?.androidBuilds?.releaseNotes}
            platform={Platforms.Android}
            storeId={buildInfo?.androidBuilds?.storeId}
            distributionAppId={buildInfo?.androidBuilds?.distributionAppId}
            messages={messages}
            notify={notify}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={getAppInfo}>
            Refresh
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

AppBuildModal.defaultProps = {};

AppBuildModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subdomain: PropTypes.string.isRequired,
};

export default AppBuildModal;
